export default {
  en: {
    title: 'Surveys',
    subtitle: 'List of surveys to collect data of your customers.',
    alert: {},
    form: {
      name: {
        label: 'Name',
        help: 'This name is internal, your customers will not see.',
        error: 'Please provide a name for the survey.',
      },
      description: {
        label: 'Description',
        error: 'The max characters is {characters}',
      },
    },
    changesSaved: 'Changes saved correctly',
  },
  es: {
    title: 'Encuestas',
    subtitle: 'Lista de encuestas para recolectar información de tus clientes.',
    alert: {},
    form: {
      name: {
        label: 'Nombre',
        help: 'Este nombre es interno, tus clientes no lo verán.',
        error: 'Escriba un nombre válido para la encuesta.',
      },
      description: {
        label: 'Descripción',
        error: 'El máximo de caracteres es {characters}',
      },
    },
    changesSaved: 'Cambios guardados correctamente',
  },
  fr: {
    title: 'Enquêtes',
    subtitle: 'Liste des enquêtes pour collecter des informations auprès de vos clients.',
    alert: {},
    form: {
      name: {
        label: 'Nom',
        help: 'Ce nom est interne, vos clients ne le verront pas.',
        error: 'Veuillez entrer un nom valide pour l\'enquête.',
      },
      description: {
        label: 'Description',
        error: 'Le nombre maximum de caractères est de {characters}',
      },
    },
    changesSaved: 'Modifications enregistrées avec succès',
}

};
